import "@fontsource-variable/hanken-grotesk";
import "@fontsource-variable/geist-mono";
import "@/styles/globals.css";
import "@/lib/i18n/config";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import { App } from "@/App";
import { initSentry } from "@/lib/sentry";

void initSentry();

const root = document.getElementById("root");
if (!root) throw new Error("#root element not found");

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please reload the page.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
